<template>
  <v-dialog v-model="isDisplayed" max-width="800" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ $t("message.confirm_registration_header") }}
      </v-card-title>
      <v-card-text>
        <p>
          {{ $t("message.confirm_registration") }}
        </p>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-for="item in tableContent" :key="item.header">
                <td>{{ item.header }}</td>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p class="font-weight-bold mt-4 mb-0">
          {{ $t("message.confirm_registration_warning") }}
        </p>
        <div class="d-flex align-center">
          <v-checkbox
            :value="has_accepted_tos"
            @change="$emit('update:has_accepted_tos', $event)"
          ></v-checkbox>
          <p class="pa-0 ma-0" v-html="termsAndConditionsText"></p>
        </div>
        <v-card-actions class="px-0">
          <v-btn
            text
            color="grey"
            :disabled="loading"
            @click="$emit('update:display', false)"
          >
            {{ $t("button.cancel") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="loading || !has_accepted_tos"
            @click="$emit('submit')"
          >
            {{ $t("button.register") }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SubscriptionConfirmationDialog",
  props: {
    display: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    form: {
      type: Object,
      required: true
    },
    has_accepted_tos: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    display(val) {
      if (!val) this.$emit("update:has_accepted_tos", false);
    }
  },
  computed: {
    termsAndConditionsText() {
      const link = this.$router.resolve({ name: "termsandconditions" }).href;
      return this.$t("linked.terms_and_conditions", { link });
    },
    isDisplayed: {
      get() {
        return this.display;
      },
      set(value) {
        this.$emit("update:display", value);
      }
    },
    tableContent() {
      if (!this.form) return [];

      const { license_plate, license_plate_country_code } =
        this.form.license_plate || {};

      const chosen_subscription = (
        this.$store.getters["config/getAvailableSubscriptions"] || []
      ).find(s => s.uuid === this.form.subscription);

      const has_promotion_price =
        !!chosen_subscription &&
        chosen_subscription.promotion_duration_in_payment_cycles !== null &&
        chosen_subscription.promotion_duration_in_payment_cycles !==
          undefined &&
        chosen_subscription.promotion_price_in_cents !== null &&
        chosen_subscription.promotion_price_in_cents !== undefined;

      return [
        license_plate && {
          header: this.$t("thead.license_plate"),
          value:
            license_plate +
            (license_plate_country_code
              ? ` (${license_plate_country_code})`
              : "")
        },
        this.form.email && {
          header: this.$t("thead.email"),
          value: this.form.email
        },
        chosen_subscription &&
          chosen_subscription.name && {
            header: this.$t("thead.subscription_name"),
            value: chosen_subscription.name
          },
        has_promotion_price && {
          header: this.$tc(
            "thead.subscription_promotion",
            chosen_subscription.promotion_duration_in_payment_cycles,
            {
              n: chosen_subscription.promotion_duration_in_payment_cycles,
              duration: this.$options.filters.subscription_duration(
                chosen_subscription.payment_cycle,
                chosen_subscription.promotion_duration_in_payment_cycles
              )
            }
          ),
          value: this.$options.filters.currency(
            chosen_subscription.promotion_price_in_cents / 100
          )
        },
        !isNaN(
          chosen_subscription
            ? chosen_subscription.product_price_in_cents
            : undefined
        ) && {
          header: has_promotion_price
            ? this.$t("thead.subscription_price_after_discount")
            : this.$t("thead.subscription_price"),
          value: this.$options.filters.currency(
            chosen_subscription.product_price_in_cents / 100
          )
        }
      ].filter(Boolean);
    }
  }
};
</script>
